/* eslint-disable quotes  */
import React, { useEffect, useState, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Animated, Easing, Text, View } from 'react-native';
import { registerIconFont, Interactable, MenuButton, Icon, SearchBox } from 'LocalGluons';
import Theme from 'Theme';
import { isWeb } from 'renative';
import { useStore, withStore } from 'Store';
import { withWebSearchContext } from 'Pages/Search/WebSearchContext';
import { withSettingsNavigation } from 'Pages/Settings/components/SettingsNavigationContext/SettingsNavigationContext';
import { logEvent } from 'AppManager';
import { isTMCZEnv, APP_METADATA, MAX_WEB_WIDTH } from 'Options';
import { Device } from 'DeviceUtils';
import { useAppSelector, useAppDispatch } from 'ReduxStore/hooks';
import { useNavigation } from '@react-navigation/native';
import {
    show,
    setActiveMenuItem,
    setQuery,
    setUseSpacing
    // checkIsDetail
} from 'ReduxStore/webMenu';
import NavigationService from '../navigationService';
import styles, { TOP_BAR_HEIGHT, MINIMISED_OFFSET, TOP_BAR_TOTAL_HEIGHT } from './Menu.styles';
import { LanguageSelector, LoginButton } from './components';
import { onError } from './helpers';
import UserPopupModal from './components/UserPopupModal/UserPopupModal.web';
import { pageTypeEnum } from '../menuItemsStackFactory';
import { useNavigationPropsContext } from '../navigationPropsContext';
import { useAppEntryContext } from 'Pages/AppEntry';

const fontName = 'materialCommunityIcons';
const fontIcon = require('react-native-vector-icons/MaterialCommunityIcons').default;
const fontTTL = require('react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf');

const LIFES_SHARING = isTMCZEnv ? 'Pro společné zážitky' : "LIFE'S FOR SHARING";
registerIconFont(fontName, fontIcon, fontTTL, 'MaterialCommunityIcons');

// updated component;
const Menu = React.memo(
    (props) => {
        const [loginIconPositionData, setLoginIconPositionData] = useState({});
        const [isUserPopupActive, setIsUserPopupActive] = useState(false);
        const [isSearchActive, setIsSearchActive] = useState(false);
        // const topBarHeight = useState(new Animated.Value(TOP_BAR_HEIGHT))[0];
        // const [currenPosition, setCurrenPosition] = useState('home');
        const isMinimised = useAppSelector((state) => state.webMenu.isMinimised);
        const activeMenuItem = useAppSelector((state) => state.webMenu.activeMenuItem);
        const dispatch = useAppDispatch();
        const query = useAppSelector((state) => state.webMenu.query);
        const navigation = useNavigation();
        const { initialize } = useAppEntryContext();
        const [launguagePreFetch, setLanguagePreFetch] = useState('SK');

        const {
            items,
            userData,
            mCoreConfig,
            language,
            searchParams,
            appManager,
            setLanguage
            // setSearchParams
        } = props;

        // const { query } = searchParams || {};
        const hideMenu = userData?.showNativeConsentsScreen ?? false;
        const errorHandler = useRef(null);
        const { navigate } = useNavigationPropsContext();
        const currentActiveMenuItem = NavigationService.getActiveMenuItem();
        const [currentItem, setCurrentItem] = useState(currentActiveMenuItem);

        useEffect(() => {
            appManager.api
                .fetchLanguage()
                .then(({ applicationLanguage }) => {
                    setLanguagePreFetch(applicationLanguage);
                    setLanguage(applicationLanguage);
                    // setHasFetchedLanguage(true);
                })
                .catch(console.warn);
        }, []);

        useEffect(() => {
            const { forceUpdate } = appManager;
            errorHandler.current = onError(props);
            appManager.subscribeError(errorHandler.current);
            if (!language) {
                appManager.api
                    .fetchLanguage()
                    .then(({ applicationLanguage }) => {
                        setLanguage(applicationLanguage);
                    })
                    // .then(() => forceUpdate())
                    .catch(console.log);
            }

            return () => {
                appManager.unsubscribeError(errorHandler.current);
            };
        }, []);

        const onSearchCancel = (inputRef) => {
            dispatch(setQuery(''));
            setIsSearchActive(false);
            NavigationService.getAppNavigationInstance().popToTop();
            setTimeout(() => inputRef?.current?.focus(), 0);
        };

        const onMenuButtonPress = (item, index) => {
            setCurrentItem(item.path);
            dispatch(setActiveMenuItem(item.path));
            if (!event.defaultPrevented) {
                Device.isWeb
                    ? navigation.navigate(item.path)
                    : NavigationService.closeAppDrawerAndNavigate(item.path);
                setCurrentItem(item.path);
                dispatch(setActiveMenuItem(item.path));
            }

            // this.setState({ isMinimised: false });
            logEvent({
                type: 'user-flow',
                subtype: activeMenuItem,
                content1: 'change-menu-item',
                content2: '',
                context: `/${item.slug}`
            });

            logEvent({
                type: 'navigation',
                subtype: 'menuSelect',
                content1: item.path,
                content2: ''
            });
        };

        const onSettingsButtonPress = (item) => {
            resetSettingsNavigation(item.slug);
            dispatch(setActiveMenuItem(item.slug));
            //        this.setState({ activeMenuItem: item.slug, isMinimised: false });
            navigation.navigate(item.slug);
            logEvent({
                type: 'user-flow',
                subtype: activeMenuItem,
                content1: 'change-menu-item',
                content2: '',
                context: `/${item.slug}`
            });
        };

        const onSearch = (searchedQuery, inputRef) => {
            dispatch(setQuery(searchedQuery));
            if (!isSearchActive) {
                setIsSearchActive(true);
                dispatch(show());
                setTimeout(() => {
                    inputRef?.current?.focus();
                }, 0);
            }
            navigation.navigate('Search', {
                showSearchBox: false,
                query: searchedQuery
            });
            inputRef?.current?.focus();
        };

        const onLogoPress = () => {
            const rootRoute = userData ? 'home' : 'watch-tv';
            if (isSearchActive) onSearchCancel();
            setCurrentItem(rootRoute);
            dispatch(setActiveMenuItem(rootRoute));
            navigation.navigate(rootRoute);
            // setActiveMenuItem(rootRoute);
        };

        const setAppLanguage = async (applicationLanguage) => {
            const { api } = appManager;

            const subtitleLanguages = (await api.fetchSubtitleLanguages()) || [];
            const audioLanguages = (await api.fetchAudioLanguages()) || [];

            const preferredAudioLanguage =
                subtitleLanguages.find((lang) =>
                    lang.playerValues.includes(applicationLanguage.toLowerCase())
                )?.name || 'English';
            const preferredSubtitlesLanguage =
                audioLanguages.find((lang) =>
                    lang.playerValues.includes(applicationLanguage.toLowerCase())
                )?.name || 'English';

            await appManager.getApi().setLanguages({
                applicationLanguage,
                // This two fields need to be filled
                // even though neither is used when user is not logged in
                preferredAudioLanguage,
                preferredSubtitlesLanguage
            });
            setLanguage(applicationLanguage);
            await appManager.resetTranslations();
            initialize();
            // navigation.navigate('AppEntry');
        };

        const isItemDisplayable = (item) =>
            item.requiresLogin === undefined || (item.requiresLogin === true && userData);

        const resetSettingsNavigation = (slug) => {
            if (isWeb() && slug === pageTypeEnum.SETTINGS) {
                const { setDefaultOptionRoute } = props;
                setDefaultOptionRoute('FavoriteSettings');
            }
        };

        const onLogoutPress = () => {
            navigation.navigate('Logout', {
                onLogoutSuccess: () => {
                    navigation.navigate('AppEntry');
                }
            });
            setIsUserPopupActive(false);
        };

        return (
            <View
                style={[
                    styles.container,
                    isMinimised ? { transform: `translateY(-${MINIMISED_OFFSET}px)` } : {}
                ]}
            >
                <View style={[styles.topBar]}>
                    {!isMinimised && (
                        <View style={[styles.contentContainer, { width: MAX_WEB_WIDTH }]}>
                            <View style={{ flex: 1 }}>
                                <Icon name="logo" style={styles.logo} />
                            </View>
                            <View style={styles.topTextContainer}>
                                <Text style={styles.topText}>{LIFES_SHARING}</Text>
                            </View>
                        </View>
                    )}
                </View>
                {!hideMenu && (
                    <View style={[styles.menuContainer, { width: MAX_WEB_WIDTH }]}>
                        <View style={styles.logoContainer}>
                            <Interactable style={styles.logoPressContainer} onPress={onLogoPress}>
                                <Text style={styles.appTitleInMenu}>
                                    {APP_METADATA.webHeaderName || 'Magio TV'}
                                </Text>
                            </Interactable>
                        </View>
                        <View style={styles.centerElement}>
                            {items.map((item, index) => {
                                if (isItemDisplayable(item) && !item.webMenuIcon) {
                                    return (
                                        <MenuButton
                                            testID={item.slug}
                                            key={item.slug}
                                            title={item.title.toUpperCase()} // todo: HERE CAN BE REPORTED ERROR FROM CONSOLE
                                            isActive={activeMenuItem === item.path}
                                            onPress={() => {
                                                onMenuButtonPress(item, index);
                                            }}
                                        />
                                    );
                                }

                                return null;
                            })}
                        </View>
                        <View style={styles.rightMenuOptionsContainer}>
                            {!userData && (
                                <LanguageSelector
                                    onSelect={setAppLanguage}
                                    languages={mCoreConfig.stringModifications.map(
                                        (item) => item.language
                                    )}
                                    currentLanguage={language || launguagePreFetch}
                                    style={{ marginRight: 6 }}
                                />
                            )}
                            <SearchBox
                                value={query}
                                onSearch={onSearch}
                                onSearchCancel={onSearchCancel}
                            />
                            {items.map((item) => {
                                // icon of settings is represented in this block
                                if (isItemDisplayable(item) && item.webMenuIcon) {
                                    // if (item.slug === 'wat') {
                                    return (
                                        <View
                                            key={item.slug}
                                            style={[
                                                styles.iconButtons,
                                                {
                                                    borderBottomColor:
                                                        activeMenuItem !== item.path
                                                            ? 'transparent'
                                                            : Theme.primaryTextColor
                                                }
                                            ]}
                                        >
                                            <Icon
                                                testID={`${item.slug}_button`}
                                                name={item.webMenuIcon}
                                                style={styles.iconSize}
                                                onPress={() => onSettingsButtonPress(item)}
                                            />
                                        </View>
                                    );
                                }
                                return null;
                            })}
                            <View style={styles.loginButtonWeb}>
                                <LoginButton
                                    isUserLoggedIn={Boolean(userData)}
                                    onPress={(event) => {
                                        if (userData) {
                                            const boundingRect =
                                                event.target.getBoundingClientRect();
                                            setIsUserPopupActive(!isUserPopupActive),
                                                setLoginIconPositionData({
                                                    loginIconPositionData: {
                                                        top: boundingRect.top,
                                                        left: boundingRect.left,
                                                        right: boundingRect.right,
                                                        width: boundingRect.width,
                                                        height: boundingRect.height
                                                    }
                                                });
                                        } else {
                                            navigation.navigate('Login', {
                                                onLoginSuccess: () => {
                                                    navigation.navigate('AppEntry', {
                                                        showSplash: false
                                                    });
                                                }
                                            });
                                        }
                                    }}
                                    isPressed={isUserPopupActive}
                                />
                                {isUserPopupActive && (
                                    <UserPopupModal
                                        onLogoutPress={onLogoutPress}
                                        userData={userData}
                                        visible={isUserPopupActive}
                                        onRequestClose={() => {
                                            setIsUserPopupActive(false);
                                        }}
                                        loginIconPosition={loginIconPositionData}
                                    />
                                )}
                            </View>
                        </View>
                    </View>
                )}
            </View>
        );
    },
    (prevProps, nextProps) =>
        // todo:check here
        prevProps.items === nextProps.items && prevProps.userData === nextProps.userData
);

Menu.defaultProps = {
    navigation: {}, // NavigationService.getAppNavigationInstance(),
    userData: null,
    language: ''
};

Menu.propTypes = {
    navigation: PropTypes.shape({}),
    items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    appManager: PropTypes.shape({}).isRequired,
    userData: PropTypes.shape({}),
    mCoreConfig: PropTypes.shape({}).isRequired,
    language: PropTypes.string,
    searchParams: PropTypes.shape({ query: PropTypes.string }).isRequired,
    setSearchParams: PropTypes.func.isRequired,
    setLanguage: PropTypes.func.isRequired
};

const menuWithSettings = withSettingsNavigation(Menu);
const menuWithWebSearchContext = withWebSearchContext(menuWithSettings);

export default withStore(menuWithWebSearchContext);
